import styled from 'styled-components';
import { theme } from '@/styles/theme';
import { Container, Section, Grid } from '@/components/ui/Container';
import { FadeInWhenVisible } from '@/components/animations/FadeInWhenVisible';

const PageHeader = styled(Section)`
  background: ${theme.colors.primary.navy};
  color: ${theme.colors.neutral.white};
  text-align: center;
  padding: ${theme.spacing[24]} 0 ${theme.spacing[16]};
`;

const PageTitle = styled.h1`
  color: ${theme.colors.neutral.white};
`;

const GalleryItem = styled.div`
  width: 100%;
  height: 300px;
  background: linear-gradient(135deg, ${theme.colors.secondary.ivory}, ${theme.colors.secondary.cream});
  border-radius: ${theme.borderRadius.xl};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.neutral.gray};
  cursor: pointer;
  transition: transform ${theme.transitions.fast};

  &:hover {
    transform: scale(1.05);
  }
`;

export const MediaPage = () => {
  return (
    <>
      <PageHeader>
        <Container>
          <PageTitle>Media & Galerij</PageTitle>
        </Container>
      </PageHeader>

      <Section>
        <Container>
          <FadeInWhenVisible>
            <h2 style={{ marginBottom: theme.spacing[8] }}>Foto Galerij</h2>
          </FadeInWhenVisible>

          <Grid columns={3}>
            {[1, 2, 3, 4, 5, 6].map((item, index) => (
              <FadeInWhenVisible key={item} delay={index * 0.1}>
                <GalleryItem>[Foto {item}]</GalleryItem>
              </FadeInWhenVisible>
            ))}
          </Grid>
        </Container>
      </Section>
    </>
  );
};
